<template>
  <div class="app-shell" :class="{ 'no-tabs': !showTabs }">
    <div class="bg-fx" aria-hidden="true">
      <div class="orb orb-a" />
      <div class="orb orb-b" />
      <div class="orb orb-c" />
      <div class="grid-fade" />
    </div>

    <nav v-if="showTabs" class="tabbar" aria-label="主導覽">
      <div class="nav-brand" aria-hidden="true">
        <div class="nav-mark">批</div>
        <div class="nav-title">御前簡報</div>
        <div class="nav-sub">注意力守門 · 本機</div>
      </div>

      <router-link
        to="/"
        class="tab-item"
        :class="{ active: isBrief }"
        replace
      >
        <span class="tab-ico">批</span>
        <span class="tab-lab">簡報</span>
      </router-link>
      <router-link to="/paste" class="tab-item" active-class="active">
        <span class="tab-ico">＋</span>
        <span class="tab-lab">入匣</span>
      </router-link>
      <router-link to="/taste" class="tab-item" active-class="active">
        <span class="tab-ico">識</span>
        <span class="tab-lab">品味</span>
      </router-link>
      <router-link to="/settings" class="tab-item" active-class="active">
        <span class="tab-ico">門</span>
        <span class="tab-lab">收文</span>
      </router-link>

      <div class="nav-foot">
        <span class="nav-kbd">快捷</span>
        <span class="nav-kbd-line">← 這篇普通 · → 有興趣 · ↑ 存</span>
      </div>
    </nav>

    <main class="app-main">
      <router-view v-slot="{ Component }">
        <transition name="fade" mode="out-in">
          <component :is="Component" />
        </transition>
      </router-view>
    </main>

    <div class="toast" :class="{ show: !!feed.toast }" role="status">
      {{ feed.toast }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { useFeedStore } from '@/stores/feed'

const route = useRoute()
const feed = useFeedStore()
const showTabs = computed(() => route.name !== 'login')
const isBrief = computed(() => route.name === 'hub' || route.name === 'review')
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.15s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
